import styled from 'styled-components';
var SubTitleStyles = styled.h2.withConfig({
  displayName: "SubTitlestyles__SubTitleStyles",
  componentId: "pantheon__bsohv9-0"
})(["font-size:1.5rem;color:#454545;"]);
export { SubTitleStyles };